module.exports = __webpack_public_path__ + "static/img/7_bg.70ef5008.png";